import './utils';

const feedbackElement = document.getElementById('feedback');

window.selectCat = (el) => {
    document.querySelectorAll('.cat-option').forEach(c => c.classList.remove('act'));
    el.classList.add('act');
}

if (feedbackElement) {
    feedbackElement.addEventListener('submit', async e => {
        e.preventDefault();
        const form = e.target;

        await fetch(form.getAttribute('action'), {
            method: 'POST',
            body: JSON.stringify({
                category: form.querySelector('input[name="cat"]').value,
                name: form.querySelector('input[name="name"]').value,
                phone: form.querySelector('input[name="phone"]').value,
                company: form.querySelector('input[name="company"]').value,
                subject: form.querySelector('input[name="subject"]').value,
                message: form.querySelector('textarea[name="message"]').value,
            }),
            headers: new Headers({
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': form.querySelector('input[name="_token"]').value,
            })
        }).then(async (response) => {
            const data = await response.json();

            if (response.status !== 200) {
                messages(data);
                return;
            }
            form.reset();
            feedbackElement.style.display = 'none';
            document.getElementById('formSuccess').style.display = 'block';
        });
    });
}
window.toggleFaq = (el) => {
    const wasOpen = el.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(f => f.classList.remove('open'));
    if (!wasOpen) el.classList.add('open');
}

// Scroll-triggered fade-in
const obs = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            obs.unobserve(entry.target);
        }
    });
}, {threshold: 0.1});

document.querySelectorAll('.hero, .channels, .form-card, .sidebar, .faq-card, .ft-line, .ft')
    .forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
        obs.observe(el);
    });
